var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBirthday = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 11.5C18.7761 11.5 19 11.2761 19 11V8C19 7.44772 19.4477 7 20 7C20.5523 7 21 7.44772 21 8V11C21 11.2761 21.2239 11.5 21.5 11.5H31.25C31.8023 11.5 32.25 11.9477 32.25 12.5V20C32.25 20.2761 32.4739 20.5 32.75 20.5H37.25C37.8023 20.5 38.25 20.9477 38.25 21.5V36.5C38.25 37.0523 37.8023 37.5 37.25 37.5H4.25C3.69772 37.5 3.25 37.0523 3.25 36.5V21.5C3.25 20.9477 3.69771 20.5 4.25 20.5H8.75C9.02614 20.5 9.25 20.2761 9.25 20V12.5C9.25 11.9477 9.69772 11.5 10.25 11.5H18.5ZM35.75 29.5C36.0261 29.5 36.25 29.2761 36.25 29V23C36.25 22.7239 36.0261 22.5 35.75 22.5H5.75C5.47386 22.5 5.25 22.7239 5.25 23V29C5.25 29.2761 5.47386 29.5 5.75 29.5H35.75ZM5.75 30.75C5.47386 30.75 5.25 30.9739 5.25 31.25V35C5.25 35.2761 5.47386 35.5 5.75 35.5H35.75C36.0261 35.5 36.25 35.2761 36.25 35V31.25C36.25 30.9739 36.0261 30.75 35.75 30.75H5.75ZM11.75 13.5C11.4739 13.5 11.25 13.7239 11.25 14V20C11.25 20.2761 11.4739 20.5 11.75 20.5H29.75C30.0261 20.5 30.25 20.2761 30.25 20V14C30.25 13.7239 30.0261 13.5 29.75 13.5H11.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C20.5523 2.5 21 2.94772 21 3.5V4.25C21 4.80228 20.5523 5.25 20 5.25C19.4477 5.25 19 4.80228 19 4.25V3.5C19 2.94771 19.4477 2.5 20 2.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBirthday);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/birthday.236f0753ebbc6f19f814174c55b4e063.svg";